import { Table, TableCell, TableRow, Checkbox, styled } from "@mui/material";

export const DenseHeaderCell = styled(TableCell)(() => ({
  padding: ".25rem .5rem",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 0,
  overflow: "hidden"
}));

export const DenseBodyCell = styled(TableCell)(() => ({
  padding: "4px 10px",
  maxWidth: 0,
  "@media (max-width: 480px)": {
    padding: "4px",
    "&:last-child ": {
      padding: "4px!important"
    }
  }
}));

export const BoldCell = styled(TableCell)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold
}));

export const MinWidthTable = styled(Table)(({ value = "800px" }) => ({
  "@media (max-width: 480px)": {
    minWidth: value,
    "& td": {
      padding: "8px",
      wordBreak: "break-all"
    }
  }
}));

export const RoundedHeaderTableRow = styled(TableRow)(({ theme }) => ({
  '& > th:first-child': {
    borderTopLeftRadius: theme.spacing(1),
    borderBottomLeftRadius: theme.spacing(1)
  },
  '& > th:last-child': {
    borderTopRightRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1)
  }
}));

export const ThemedHeaderTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  fontWeight: 'bold',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const ThinCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));